var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useId } from 'react';
import { useNavigate } from 'react-router-dom';
import { invitationErrorMessages, } from '@lucidlink/dto/validation';
import { BadRequestError } from '@lucidlink/sdk/fetcher';
import { Button, Modal, Strong, Trans, translate, useToastService, } from '@lucidlink/uicore';
import { PII_MASK_CLASS } from '#constants';
import { useDeclineInvitation } from '#query-hooks';
import { workspaceRoutes } from '#services';
import { ModalActions, ModalDescription, ModalTitle } from '../components';
// All declineInvitation.* codes are terminal; derive from DTO to avoid drift
const handledDeclineErrors = Object.keys(invitationErrorMessages.declineInvitation).map((code) => `declineInvitation.${code}`);
export const DeclineInvitationModal = ({ closeModal, workspaceId, workspaceName, }) => {
    _react_refresh_temp_2();
    const titleId = useId();
    const navigate = useNavigate();
    const { addToast } = useToastService();
    const closeAndLeaveWorkspaceRoute = useCallback(() => {
        closeModal();
        void navigate(workspaceRoutes.workspaces());
    }, [closeModal, navigate]);
    const { mutation: { isPending, mutate: declineInvitation }, } = useDeclineInvitation(workspaceId, {
        onError: (error) => {
            const errorCode = (error instanceof BadRequestError && error.errors[0]?.code) ||
                '';
            const isHandledError = handledDeclineErrors.some((code) => errorCode === code);
            addToast({
                content: {
                    message: isHandledError
                        ? translate(errorCode)
                        : translate('You were unable to decline the invitation to the {{workspaceName}} workspace.', { workspaceName }),
                },
                kind: 'negative',
                'data-testid': 'decline-invitation-failure',
            });
            // A handled code is terminal — retrying cannot succeed, so close
            // and let the (already refetched) state drive the UI
            if (isHandledError) {
                closeAndLeaveWorkspaceRoute();
            }
        },
        onSuccess: () => {
            addToast({
                content: {
                    message: translate('You successfully declined the invitation to the {{workspaceName}} workspace.', { workspaceName }),
                },
                kind: 'positive',
                'data-testid': 'decline-invitation-success',
            });
            closeAndLeaveWorkspaceRoute();
        },
    });
    const onConfirm = () => {
        declineInvitation();
    };
    return (_jsxs(Modal, { "aria-labelledby": titleId, closeModal: closeModal, children: [_jsx(ModalTitle, { id: titleId, children: _jsxs(Trans, { shouldUnescape: true, values: { workspaceName }, children: ["Are you sure you want to decline the invitation to the", _jsx("br", {}), _jsx(Strong, { className: PII_MASK_CLASS, wordBreak: "breakWord", children: '{{workspaceName}}' }), ' ', "workspace?"] }) }), _jsx(ModalDescription, { children: _jsx(Trans, { children: "You will lose access to this workspace and any permissions granted to you. The workspace admin can invite you again." }) }), _jsxs(ModalActions, { children: [_jsx(Button, { "data-testid": "cancel-decline-invitation", isFullWidth: true, kind: "secondary", onClick: closeModal, size: "big", children: _jsx(Trans, { children: "Cancel" }) }), _jsx(Button, { "data-testid": "confirm-decline-invitation", isFullWidth: true, isLoading: isPending, kind: "primary", onClick: onConfirm, size: "big", children: _jsx(Trans, { children: "Yes, decline" }) })] })] }));
};
_react_refresh_temp_1 = DeclineInvitationModal;
$RefreshReg$(_react_refresh_temp_1, "DeclineInvitationModal");
_react_refresh_temp_2(DeclineInvitationModal, "lZN7TRizdDoHr9AoG0Ej5vDbxaw=", false, () => [useNavigate, useToastService, useDeclineInvitation]);
